import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';

import { LmsTableWrapperComponent } from '@lmsShared';
import { ZARcurrencyPipe } from '@lmsSharedPipes';

// Import large libraries dynamically
async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-branch-loans-report',
  templateUrl: './branch-loans-report.component.html',
  styleUrls: ['./branch-loans-report.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ZARcurrencyPipe, NgxPaginationModule, LmsTableWrapperComponent],
})
export class BranchLoansReportComponent implements OnInit {
  loansList: any[] = [];
  title = 'export-excel';
  fileName = '';
  @ViewChild('TABLE') table: ElementRef;
  dataSource = this.loansList;
  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 15,
    currentPage: 1,
  };

  docCount = 1;
  constructor(public global_utility: AppUtilityService, public dialogRef: MdbModalRef<BranchLoansReportComponent>) {}

  ngOnInit(): void {}

  exportLoansToExcel(): void {
    this.title = 'export-excel';
    this.fileName = `Branch Report_${new Date()}.xlsx`;

    this.global_utility.startLoading('Exporting data to Excel.');
    loadXLSX()
      .then((XLSX) => {
        /* pass here the table id */
        //const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.lstQuotes);
        // table_to_sheet(this.lstQuotes);
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);

        /* generate workbook and add the worksheet */

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */

        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to import Excel:', err);
      });
  }

  getStatusClass(status: string): string {
  const normalized = 'status-' + (status ?? '').toLowerCase().replace(/\s+/g, '-');
  return normalized;
}

  close() {
    this.dialogRef.close();
  }
}
